import React from 'react';
import { Column } from '../../../../hooks/useTablePages';
import { constantToLabel } from '@ecosconnect/core/src/helpers/string';
import { format, parseISO } from 'date-fns';
import { WaterSiteItem } from './WaterSites.query';

const columns: Column[] = [
  {
    header: 'Name',
    accessor: 'name',
    width: 160,
  },
  {
    header: 'Site Number',
    accessor: 'siteNumber',
    width: 120,
  },
  {
    header: 'Type',
    id: 'type',
    accessor: (row: WaterSiteItem) => constantToLabel(row.type),
    width: 150,
  },
  {
    header: 'Contact',
    accessor: 'contact.name',
    width: 150,
  },
  {
    header: 'Supervisor',
    accessor: 'supervisor.name',
    width: 150,
  },
  {
    header: 'Assigned To',
    accessor: 'assignedTo.name',
    width: 150,
  },
  {
    header: 'Last Surveyed',
    id: 'lastSurveyDate',
    accessor: (row: any) => {
      if (!row.lastSurveyDate || row.lastSurveyDate.startsWith('00')) {
        return '';
      }
      return format(parseISO(row.lastSurveyDate), 'M/d/yyyy');
    },
    width: 120,
  },
  {
    header: 'Next Survey',
    id: 'nextSurveyDate',
    accessor: (row: any) => {
      if (!row.nextSurveyDate || row.nextSurveyDate.startsWith('00')) {
        return '';
      }
      return format(parseISO(row.nextSurveyDate), 'M/d/yyyy');
    },
    width: 120,
  },
  {
    header: 'Survey Interval',
    id: 'surveyIntervalYears',
    accessor: (row: any) =>
      `${row.surveyIntervalYears} year${
        row.surveyIntervalYears == 1 ? '' : 's'
      }`,
    width: 130,
  },
  {
    header: 'Last Inspection',
    id: 'lastInspectionDate',
    accessor: (row: WaterSiteItem) => {
      if (!row.lastInspectionDate || row.lastInspectionDate.startsWith('00')) {
        return '';
      }
      return format(parseISO(row.lastInspectionDate), 'M/d/yyyy');
    },
    width: 145,
  },
  {
    header: 'Next Inspection',
    id: 'nextInspectionDate',
    accessor: (row: WaterSiteItem) => {
      if (!row.nextInspectionDate || row.nextInspectionDate.startsWith('00')) {
        return '';
      }
      return format(parseISO(row.nextInspectionDate), 'M/d/yyyy');
    },
    width: 145,
  },
  {
    header: 'Address',
    id: 'address.street1',
    accessor: (row: any) =>
      row.address.street1 +
      (row.address.street2 ? ', ' + row.address.street2 : ''),
    width: 250,
  },
  {
    header: 'City',
    accessor: 'address.city',
    width: 120,
  },
  {
    header: 'State',
    accessor: 'address.state',
    width: 80,
  },
  {
    header: 'Zip',
    id: 'address.zip',
    accessor: (row: any) =>
      row.address.zip + (row.address.zipExt ? '-' + row.address.zipExt : ''),
    width: 120,
  },
];

export default columns;
